export default __webpack_public_path__ + "static/media/location.d9fe6293.png";